import React, { useEffect, useState } from "react";
import { Mountain, X } from "lucide-react";

const KEY = "mp_beta_notice_dismissed_v1";

export default function BetaNotice() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  const close = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      data-testid="beta-notice-overlay"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={close} />
      <div className="relative paper-card max-w-md w-full p-8 animate-in" data-testid="beta-notice-card">
        <button
          onClick={close}
          aria-label="Close"
          data-testid="beta-notice-x"
          className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center text-[#8A8A8A] hover:bg-[#F0EBE1] transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-2 mb-4">
          <Mountain className="w-6 h-6" style={{ color: "var(--mp-terracotta)" }} />
          <span className="font-script text-2xl text-[#5C5C5C]">a quick hello</span>
        </div>

        <h2 className="font-serif-display text-3xl mb-3">We're a brand-new site!</h2>
        <p className="text-[#5C5C5C] mb-3">
          MemoryPeaks is fresh out of the box and still under active development, so you may
          run into a few unexpected things along the way.
        </p>
        <p className="text-[#5C5C5C] mb-3">
          If you have any questions, problems, or suggestions, please email us at{" "}
          <a href="mailto:info@memorypeaks.com" className="text-[#8C3A3A] underline underline-offset-2" data-testid="beta-notice-email">
            info@memorypeaks.com
          </a>. We truly appreciate your help testing as we build the site out.
        </p>
        <p className="text-sm text-[#8A8A8A] mb-6">Close this message to continue on to the site.</p>

        <button onClick={close} className="btn-primary w-full" data-testid="beta-notice-close-btn">
          Close &amp; continue
        </button>
      </div>
    </div>
  );
}
